import {createSelector} from 'reselect';
import {getAppState} from './appStateSelector';
import {modalCreateUpdateEmployeeStateSelector} from './manageEmployeeStateSelector';

const getTeamAssignmentState = (state) => state?.teamAssignmentState ?? {};
export const selectProjects = (state) => state.teamAssignmentState.projects;

export const teamAssignmentSelector = createSelector(
  [getTeamAssignmentState],
  ({saveAssignButton, assignedEmployee, employeeIdToRoleChange, employeeIdToAssign, selectedProject}) => ({
    saveAssignButton,
    assignedEmployee,
    employeeIdToRoleChange,
    employeeIdToAssign,
    selectedProject,
  })
);

export const availableEmployeeSelector = createSelector([getTeamAssignmentState], (teamState) => {
  const allEmployees = Array.isArray(teamState.availableEmployee) ? teamState.availableEmployee : [];
  const assignedEmployees = Array.isArray(teamState.assignedEmployee) ? teamState.assignedEmployee : [];
  const assignedIds = new Set(assignedEmployees.map((e) => e.id));
  return allEmployees.filter((emp) => !assignedIds.has(emp.id) && emp.lastDay == null);
});

export const sortedDepartmentsSelector = createSelector([modalCreateUpdateEmployeeStateSelector], ({departments}) =>
  departments ? [...departments].sort((a, b) => a.departmentName.localeCompare(b.departmentName)) : []
);

export const userAndProjectSelector = createSelector(
  [getAppState, getTeamAssignmentState],
  (appState, teamAssignmentState) => ({
    user: appState?.user,
    selectedProject: teamAssignmentState?.selectedProject,
  })
);

export const selectTeamMemberHistory = createSelector(
  [getTeamAssignmentState],
  (state) => state.historyData ?? []
);

export const selectIsLoadingHistory = createSelector(
  [getTeamAssignmentState],
  (state) => state.isLoadingHistory ?? false
);

export const selectIsLoadingTeamAssignment = createSelector(
  [getTeamAssignmentState],
  (state) => state.isLoadingTeamAssignment ?? false
);
